import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "toggle"]
  static values = { more: String, less: String }

  connect() {
    this.expanded = false
    this.observer = new ResizeObserver(() => this.measure())
    this.observer.observe(this.textTarget)
    this.measure()
  }

  disconnect() {
    this.observer.disconnect()
  }

  measure() {
    const height = parseFloat(getComputedStyle(this.textTarget).lineHeight) * 6
    const overflowing = this.textTarget.scrollHeight > height + 1
    this.toggleTarget.hidden = !overflowing
    this.textTarget.style.maxHeight = !this.expanded && overflowing ? `${height}px` : ""
    this.textTarget.style.overflow = !this.expanded && overflowing ? "hidden" : ""
  }

  toggle() {
    this.expanded = !this.expanded
    this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
    this.toggleTarget.textContent = this.expanded ? this.lessValue : this.moreValue
    this.measure()
  }
}
